import type { TilesCartItem } from 'stores/cartStore/CartItem'
import TileMini from './TileMini'
import * as S from './TilesThumbnail.styles'
import { ReactComponent as CartTiles } from 'icons/assets/CartTiles.svg'

type TilesThumbnailProps = {
  item: TilesCartItem
}

function TilesThumbnail({ item }: TilesThumbnailProps) {
  const { thumb, backgroundThumb } = item.metadata

  const frontTile = thumb ? (
    <TileMini
      thumbUrl={thumb.thumbUrl}
      crop={thumb.crop}
      frameColor={thumb.frameColor}
      materialType={thumb.materialType}
      matting={thumb.matting}
      mattingColor={thumb.mattingColor}
      filter={thumb.filter}
      tileSize={thumb.tileSize}
      includeShadow
    />
  ) : (
    <S.ThumbnailWrapper>
      <CartTiles />
    </S.ThumbnailWrapper>
  )

  return (
    <S.Stack>
      {backgroundThumb && (
        <S.BackTile aria-hidden>
          <TileMini
            thumbUrl={backgroundThumb.thumbUrl}
            crop={backgroundThumb.crop}
            frameColor={backgroundThumb.frameColor}
            materialType={backgroundThumb.materialType}
            matting={backgroundThumb.matting}
            mattingColor={backgroundThumb.mattingColor}
            filter={backgroundThumb.filter}
            tileSize={backgroundThumb.tileSize}
            includeShadow={false}
          />
        </S.BackTile>
      )}
      <S.FrontTile>{frontTile}</S.FrontTile>
    </S.Stack>
  )
}

export default TilesThumbnail
